import ability from './ability'

// export const canNavigate = to => to.matched.some(route => ability.can(route.meta.action || 'read', route.meta.resource))

// Fungsi utama untuk mengecek apakah route bisa diakses
export const canNavigate = to => {
  // Jika route bersifat publik
  if (to.matched.some(route => route.meta?.public)) {
    return true
  }

  // Jika route memiliki aturan ACL, periksa permission-nya
  return to.matched.some(route => ability.can(route.meta.action || 'read', route.meta.resource))
}

export const _ = undefined
